import { Component, Input } from '@angular/core';

import { SportCountryAvatarsComponent } from '../../sport-country-avatars/sport-country-avatars.component';
import { NgIf, NgClass, DecimalPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { VideoSection } from '@kinomap-dev/ng-ui-lib';

@Component({
  selector: 'app-video-poster-card',
  templateUrl: './video-poster-card.component.html',
  styleUrls: ['./video-poster-card.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    NgClass,
    SportCountryAvatarsComponent,
    DecimalPipe,
  ],
})
export class VideoPosterCardComponent {
  @Input() video!: VideoSection;
  @Input() rank!: number;
  @Input() isVideoPreview: boolean = false;

  constructor() {}
}
